import { ReactNode } from 'react';

import { Skeleton, SkeletonProps } from '@any-ui-react/core';

export type SkeletonLoaderProps = {
  loading?: boolean;
  children?: ReactNode;
} & SkeletonProps;

export const SkeletonLoader = ({
  loading,
  children,
  variant = 'default',
  height = 14,
  ...rest
}: SkeletonLoaderProps) => {
  return (
    <>
      {loading ? (
        <Skeleton
          key="skeleton-loading"
          visible={loading}
          variant={variant}
          height={height}
          {...rest}
        />
      ) : (
        <div key="skeleton-content" className="contents">
          {children}
        </div>
      )}
    </>
  );
};
